// extracted by mini-css-extract-plugin
export default {"popup":"style_popup__scWkK","close":"style_close__wf9ty","overlay":"style_overlay__6ZAts"};